import { Component, ChangeDetectionStrategy, HostBinding, OnDestroy, inject, input, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppSettings } from '@services/settings/app-settings.service';

@Component({
  selector: 'app-mobile-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './mobile-footer.component.html',
  styleUrls: ['./mobile-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileFooterComponent implements OnDestroy {
  public appSettings = inject(AppSettings);
  visible = input(true);
  /** Fondo #0f172a (mismo chrome del visor de documentos). */
  dark = input(false);
  /**
   * Overlay fullscreen: bottom 0 + z-index alto,
   * sin offset de la barra de navegación móvil.
   */
  overlay = input(false);
  /**
   * Dentro de un host fullscreen (viewer): el bar fluye en el layout
   * en lugar de position:fixed.
   */
  embedded = input(false);

  private static activeCount = 0;
  private applied = false;

  @HostBinding('class.is-visible')
  get isVisible(): boolean {
    return this.appSettings.isMobile() && this.visible();
  }

  @HostBinding('class.is-dark')
  get isDark(): boolean {
    return this.dark();
  }

  @HostBinding('class.is-overlay')
  get isOverlay(): boolean {
    return this.overlay();
  }

  @HostBinding('class.is-embedded')
  get isEmbedded(): boolean {
    return this.embedded();
  }

  constructor() {
    effect(() => {
      // Overlay/embedded no empujan el body: el host ya cubre o fluye en su contenedor.
      this.syncBodyClass(
        this.appSettings.isMobile() && this.visible() && !this.overlay() && !this.embedded()
      );
    });
  }

  ngOnDestroy(): void {
    this.syncBodyClass(false);
  }

  private syncBodyClass(active: boolean): void {
    if (active && !this.applied) {
      this.applied = true;
      MobileFooterComponent.activeCount += 1;
      document.body.classList.add('has-mobile-footer');
      return;
    }
    if (!active && this.applied) {
      this.applied = false;
      MobileFooterComponent.activeCount = Math.max(0, MobileFooterComponent.activeCount - 1);
      if (MobileFooterComponent.activeCount === 0) {
        document.body.classList.remove('has-mobile-footer');
      }
    }
  }
}
